import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesProvince = {
  name: '',
  region: '',
  code: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageProvinceListInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesProvince}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageProvinceListInitializer.displayName = 'Page Province List initializer component';

export default PageProvinceListInitializer;
